<template>
  <div>
    <mc-top-bar :product="pageName" :productshort="pageName">
      <!--<small style="margin-top: 5px;margin-left: -15px;font-style: italic;">{{ pageNameDescription }}</small>-->
      <mc-tooltip v-if="productCreatedBy || fbpOwner" class="product-created-details-div" fit="small" :class="fbpOwner.length==0 ? 'mt-6' : ''" style="margin-left: -20px;">
        <mc-icon slot="trigger" icon="info-circle" color="#42b0d5"></mc-icon>
        <span>
          <small><strong>Onboarded By-</strong>{{ productCreatedBy }}</small><br>
          <small v-if="fbpOwner.length > 0"><strong>FBP Owner-</strong>{{ fbpOwner }}</small>
        </span>
      </mc-tooltip>

      <div v-if="productCreatedBy || fbpOwner" class="back-to-collection-top-bar">
        <mc-button
            icon="arrow-left"
            appearance="neutral"
            variant="outlined"
            label="Back to Collection"
            fit="small"
            @click="backToCollection"
        />
      </div>

      <div slot="actions">
        <mc-menu trigger="click">
          <mc-avatar
              slot="trigger"
              :initials="userinit"
              info="info"
              hiddentooltip
              fit="small"
              appearance="color-3"
          />

          <div class="mds-grid mds-grid-cols-1 profile-content">
            <div class="mds-grid-col-span-1 text-center">
              <span>{{ username }}</span>
            </div>

            <div class="mds-grid-col-span-1 text-center">
              <span>
                <strong>Email:</strong> {{ useremail }}
              </span>
            </div>
            <br>
            <div class="mds-grid-col-span-1 text-center">
              <mc-button fit="small" @click="signOut">
                Sign Out
              </mc-button>
            </div>
          </div>
        </mc-menu>
      </div>
    </mc-top-bar>
  </div>
</template>
<script>
import '@maersk-global/mds-components-core-tooltip';
import "@maersk-global/mds-components-core-top-bar";
import "@maersk-global/mds-components-core-menu";
import "@maersk-global/mds-components-core-button";
import "@maersk-global/mds-components-core-list";
import "@maersk-global/mds-components-core-list-item";
import "@maersk-global/mds-components-core-avatar";
import { PublicClientApplication } from "@azure/msal-browser";

export default {
  name: "AppBar",
  props: {
    username: {
      type: String,
      required: true
    },
    useremail: {
      type: String,
      required: true
    },
    userinit: {
      type: String,
      required: true
    },
    pageName: {
      type: String,
      required: true
    },
    pageNameDescription: {
      type: String,
      required: true
    },
    productCreatedBy: {
      type: String,
      required: true
    },
    fbpOwner: {
      type: String,
      required: true
    },
  },
  //emits: ["signOutEventBus"],
  data() {
    return {
    };
  },
  created() {
    this.msalLibrary = new PublicClientApplication(
        this.$store.state.msalConfig
    );
    try {
      // Your logic here
      console.log('AppBar created hook')
    } catch (error) {
      console.error('Error in AppBar created hook:', error)
    }
  },
  methods: {
    signOut: async function () {
      await this.msalLibrary
          .logout({})
          .then(() => {
            localStorage.clear(); // For Clearing Local Storage
            sessionStorage.clear(); // For Clearing Session Storage
            this.loggedInSuccess = false; //uncomment during deployment
            document.cookie.split(";").forEach(function (c) {
              // For Clearing the Cookies
              document.cookie = c
                  .replace(/^ +/, "")
                  .replace(
                      /=.*/,
                      "=;expires=" + new Date().toUTCString() + ";path=/"
                  );
            });
          })
          .catch((error) => {
            console.error(error);
          });
    },
    backToCollection(){
      this.$router.push({ name: 'BowlerChartCollection', params: { mode: 'collection' } });
    },
  }
};
</script>
<style scoped>
mc-avatar {
  margin-left: 8px;
}

.profile-content {
  min-width: 240px;
  padding: 16px;
  row-gap: 12px;
}

.profile-content mc-divider {
  width: 100%;
  margin: 12px 0;
}

</style>
